"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setState = exports.setAppDefsObject = exports.initialState = exports["default"] = void 0;
var _reduxActions = require("redux-actions");
var _set2 = _interopRequireDefault(require("lodash/set"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Initial state
var initialState = exports.initialState = window.cccisd.appDefs;

// Actions
var SET_STATE = 'appdefs/appDefsObject/SET_STATE';

// Action Creators
var setState = exports.setState = (0, _reduxActions.createAction)(SET_STATE);

/* ***************************************************** */
/* ****************** CUSTOM ACTIONS ******************* */
/* ***************************************************** */

var setAppDefsObject = exports.setAppDefsObject = function setAppDefsObject(object) {
  return function (dispatch, getState) {
    dispatch(setState(object));
    (0, _set2["default"])(window, 'cccisd.appDefs', object);
  };
};

// Reducers
var _default = exports["default"] = (0, _reduxActions.handleActions)(_defineProperty({}, SET_STATE, function (state, action) {
  return action.payload;
}), initialState);